// extracted by mini-css-extract-plugin
module.exports = {"errors":"DeviceModificationResultModal_errors__ECsck"};